import { render, staticRenderFns } from "./RentManage.vue?vue&type=template&id=baaf0d0a&scoped=true"
import script from "./RentManage.vue?vue&type=script&lang=js"
export * from "./RentManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baaf0d0a",
  null
  
)

export default component.exports